import { getFaireDirectBrandAlias } from "@faire/deprecated-retailer-visitor-shared/app/_lib/data/faireDirect";
import { useSettingFaireDirectCreditForVisitorPhase1 } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingFaireDirectCreditForVisitor";
import { useQuery as useFaireDirectBrandsForVisitorQuery } from "@faire/web-api--source/endpoints/www/api/faire-direct/faire-direct-brands-for-visitor/get-hooks";
import { trackFaireDirectFaireDirectForCurrentLocationActionCategoryError } from "@faire/web-api--source/events/faireDirect/actionCategoryError/faireDirectForCurrentLocation";
import { usePathname, useSearchParams } from "next/navigation";
import qs from "query-string";
import { useEffect, useMemo } from "react";

import { getFaireDirectBrandFromTokenOrAlias } from "./getFaireDirectBrandFromTokenOrAlias";

export const useFaireDirectBrandsForVisitor = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isFaireDirectCreditForVisitorPhase1 =
    useSettingFaireDirectCreditForVisitorPhase1();
  const { data, isPending } = useFaireDirectBrandsForVisitorQuery({
    staleTime: Infinity,
    refetchOnMount: false,
    enabled: isFaireDirectCreditForVisitorPhase1,
  });
  const brandAlias = pathname
    ? getFaireDirectBrandAlias(pathname, qs.parse(searchParams.toString()))
    : undefined;

  const faireDirectBrandsForVisitor = useMemo(() => {
    return data?.faire_direct_brands;
  }, [data?.faire_direct_brands]);

  useEffect(() => {
    if (!brandAlias || isPending) {
      return;
    }
    // check the data includes faireDirectBrand from current location
    const includesFaireDirectBrandFromCurrentLocation =
      getFaireDirectBrandFromTokenOrAlias(
        { brandAlias },
        faireDirectBrandsForVisitor
      );
    if (!includesFaireDirectBrandFromCurrentLocation) {
      const searchParamsString = searchParams.toString()
        ? `?${searchParams.toString()}`
        : "";
      trackFaireDirectFaireDirectForCurrentLocationActionCategoryError(
        `${pathname}${searchParamsString}`,
        JSON.stringify(faireDirectBrandsForVisitor ?? [])
      );
    }
  }, [
    faireDirectBrandsForVisitor,
    brandAlias,
    isPending,
    pathname,
    searchParams,
  ]);

  return {
    faireDirectBrandsForVisitor,
    isPending,
  };
};
